"use strict";
window.theme = window.theme || {}
theme.customEngraving = function() {

    var CURVE_RADII = {
        bottle: [138, 168, 188],
        glass: [138, 348],
        drop: [138, 348]
    };

    var MOBILE_MQ = window.matchMedia('(max-width: 768px)');

    function parseJsonAttr(raw) {
        if (!raw) return null;
        try { var v = JSON.parse(raw); return v == null ? null : v; } catch(e) { return null; }
    }

    function toPx(raw) {
        if (raw == null || raw === '') return '';
        var n = parseInt(raw, 10);
        return isNaN(n) ? '' : n + 'px';
    }

    function customEngraving() {
        this.overlays = document.querySelectorAll('.engraving-modal-overlay');
        this.forms = document.querySelectorAll('.engraving-modal__form');
        this.openButtons = document.querySelectorAll('button.product-engraving__button');
        this.editButtons = document.querySelectorAll('.engraving-edit__button');
        this.addToCartButton = document.querySelector('.add-to-cart__button');
        this.mobileAddToCartButtons = document.querySelectorAll('.engraving-add-to-cart__button');

        this.overlay = document.querySelector('.engraving-preview-overlay');
        this.imageContainer = document.querySelector('.engraving-modal__image');
        this.overlayConfigs = {};
        this.knownTypeSlugs = [];
        this.currentOverlayType = null;

        this.goldCheckbox = document.querySelector('.gold-engraving-checkbox');
        this.goldInput = document.querySelector('.gold-engraving-input');

        this.initOverlay();
        this.load();

        var self = this;
        var mqHandler = function() { self.applyViewportStyles(); };
        if (MOBILE_MQ.addEventListener) MOBILE_MQ.addEventListener('change', mqHandler);
        else MOBILE_MQ.addListener(mqHandler);
    }

    customEngraving.prototype.initOverlay = function() {
        var _ = this;
        var configSections = document.querySelectorAll('.engraving-config-section');
        var firstTypeSlug = null;

        configSections.forEach(function(section) {
            var typeSlug = section.getAttribute('data-config-type');
            if (!typeSlug) return;
            if (!firstTypeSlug) firstTypeSlug = typeSlug;
            if (_.knownTypeSlugs.indexOf(typeSlug) === -1) _.knownTypeSlugs.push(typeSlug);

            var position = parseJsonAttr(section.getAttribute('data-preview-position'));
            var positionMobile = parseJsonAttr(section.getAttribute('data-preview-position-mobile'));

            var shapeRaw = section.getAttribute('data-preview-shape') || '';
            var isCurved = shapeRaw.toLowerCase() === 'curved';

            var directionRaw = section.getAttribute('data-preview-direction') || '';
            var isVertical = directionRaw.toLowerCase() === 'vertical';

            var fontSize = toPx(section.getAttribute('data-font-size'));
            var fontSizeMobile = toPx(section.getAttribute('data-font-size-mobile'));

            var maxLengthRaw = section.getAttribute('data-lines-max-length') || '[]';
            var lineCount = 1;
            try {
                var parsed = JSON.parse(maxLengthRaw);
                if (Array.isArray(parsed)) lineCount = parsed.length;
            } catch(e) {
                // Fallback: count inputs for this config type
                var inputCount = section.querySelectorAll('input.engraving_line').length;
                if (inputCount > 0) lineCount = inputCount;
            }

            var imageUrl = section.getAttribute('data-product-image') || '';

            var disableNumbers = (section.getAttribute('data-disable-numbers') || '').toLowerCase() === 'true';

            _.overlayConfigs[typeSlug] = {
                position: position,
                positionMobile: positionMobile,
                isCurved: isCurved,
                isVertical: isVertical,
                fontSize: fontSize,
                fontSizeMobile: fontSizeMobile,
                lineCount: lineCount,
                imageUrl: imageUrl,
                disableNumbers: disableNumbers
            };
        });

        _.firstTypeSlug = firstTypeSlug;
        if (firstTypeSlug) {
            _.switchOverlay(firstTypeSlug);
        }
    }

    customEngraving.prototype.resetToFirstImage = function() {
        var _ = this;
        if (!_.firstTypeSlug || !_.imageContainer) return;
        var cfg = _.overlayConfigs[_.firstTypeSlug];
        if (!cfg || !cfg.imageUrl) return;

        // Reset image container class
        _.knownTypeSlugs.forEach(function(slug) {
            _.imageContainer.classList.remove(slug);
        });
        _.imageContainer.classList.add(_.firstTypeSlug);

        // Switch to first config image
        var img = _.imageContainer.querySelector('img');
        if (img) {
            img.removeAttribute('srcset');
            img.src = cfg.imageUrl;
        }

        // Reset overlay state so switchOverlay will fully apply on next input focus
        _.currentOverlayType = null;
    }

    customEngraving.prototype.switchOverlay = function(typeSlug, activeLineIndex) {
        var _ = this;
        if (!_.overlay || !_.imageContainer) return;
        activeLineIndex = activeLineIndex || 0;

        // If same type, just toggle active span for glass
        if (_.currentOverlayType === typeSlug) {
            if (typeSlug === 'glass') {
                var spans = _.overlay.querySelectorAll('[data-preview-line]');
                spans.forEach(function(s) { s.style.display = 'none'; });
                var activeSpan = _.overlay.querySelector('[data-preview-line="' + activeLineIndex + '"]');
                if (activeSpan) activeSpan.style.display = '';
            }
            return;
        }

        _.currentOverlayType = typeSlug;
        var cfg = _.overlayConfigs[typeSlug];
        if (!cfg) return;

        // Update image container class
        _.knownTypeSlugs.forEach(function(slug) {
            _.imageContainer.classList.remove(slug);
        });
        _.imageContainer.classList.add(typeSlug);

        // Switch modal image if config has one
        if (cfg.imageUrl) {
            var img = _.imageContainer.querySelector('img');
            if (img) {
                img.removeAttribute('srcset');
                img.src = cfg.imageUrl;
            }
        }

        // Apply position + font-size (viewport-aware)
        _.applyViewportStyles();

        // Apply modifiers
        _.overlay.classList.toggle('curved', cfg.isCurved);
        _.overlay.classList.toggle('vertical', cfg.isVertical);

        // Create span elements for each line
        _.overlay.innerHTML = '';
        for (var i = 0; i < cfg.lineCount; i++) {
            var span = document.createElement('span');
            span.dataset.previewLine = i;
            if (typeSlug === 'glass') span.style.display = 'none';
            _.overlay.appendChild(span);
        }

        // Populate with current input values
        var form = document.querySelector('.engraving-modal__form');
        if (form) {
            var inputs = form.querySelectorAll('input.engraving_line[data-config-type="' + typeSlug + '"]');
            inputs.forEach(function(input, i) {
                var span = _.overlay.querySelector('[data-preview-line="' + i + '"]');
                if (span && input.value) {
                    span.textContent = input.value;
                    if (cfg.isCurved) _.applyCurve(span, i);
                }
            });
        }

        // Show active glass line
        if (typeSlug === 'glass') {
            var activeSpan = _.overlay.querySelector('[data-preview-line="' + activeLineIndex + '"]');
            if (activeSpan) activeSpan.style.display = '';
        }
    }

    customEngraving.prototype.applyViewportStyles = function() {
        var _ = this;
        if (!_.overlay || !_.currentOverlayType) return;
        var cfg = _.overlayConfigs[_.currentOverlayType];
        if (!cfg) return;

        var isMobile = MOBILE_MQ.matches;
        var pos = (isMobile && cfg.positionMobile) ? cfg.positionMobile : cfg.position;
        var fs = (isMobile && cfg.fontSizeMobile) ? cfg.fontSizeMobile : cfg.fontSize;

        if (pos && Array.isArray(pos) && pos.length >= 2) {
            _.overlay.style.left = pos[0] + '%';
            _.overlay.style.top = pos[1] + '%';
        }
        _.overlay.style.fontSize = fs || '';
    }

    customEngraving.prototype.applyCurve = function(el, lineIndex) {
        var _ = this;
        var cfg = _.overlayConfigs[_.currentOverlayType];
        if (!cfg || !cfg.isCurved || !el.textContent.trim()) return;

        var radii = CURVE_RADII[_.currentOverlayType] || CURVE_RADII.bottle;
        var radius = radii[Math.min(lineIndex, radii.length - 1)];

        var ct = new CircleType(el);
        ct.dir(-1).radius(radius);
        ct.forceHeight(false);
        ct.forceWidth(false);
        ct.refresh();

        // Set min-height to prevent layout shifts — always measured against a
        // single-char arc so typing vs pasting yield identical spacing.
        if (!el.dataset.minHeightSet) {
            var allSpans = _.overlay.querySelectorAll('[data-preview-line]');
            allSpans.forEach(function(span, i) {
                if (span.dataset.minHeightSet) return;
                var r = radii[Math.min(i, radii.length - 1)];
                var savedText = span.textContent;
                span.textContent = 'X';
                var probeCt = new CircleType(span);
                probeCt.dir(-1).radius(r);
                probeCt.forceHeight(false);
                probeCt.forceWidth(false);
                probeCt.refresh();
                var probeBbox = span.getBoundingClientRect();
                span.style.minHeight = probeBbox.height + 'px';
                span.dataset.minHeightSet = '1';
                probeCt.destroy();
                span.textContent = savedText;
            });

            // Re-apply CircleType to the current element with its actual content
            var restoreCt = new CircleType(el);
            restoreCt.dir(-1).radius(radius);
            restoreCt.forceHeight(false);
            restoreCt.forceWidth(false);
            restoreCt.refresh();
        }
    }

    customEngraving.prototype.clearAllPreviews = function() {
        if (!this.overlay) return;
        var spans = this.overlay.querySelectorAll('[data-preview-line]');
        spans.forEach(function(span) {
            span.innerHTML = '';
        });
    }

    customEngraving.prototype.restoreFromRecap = function() {
        var _ = this;
        var openBtn = _.openButtons[0];
        if (!openBtn) return;
        var recap = openBtn.querySelector('.engraving-recap');
        if (!recap || recap.classList.contains('d-none')) return;

        var recapItems = recap.querySelectorAll('.engraving-recap-item');
        _.forms.forEach(function(form) {
            recapItems.forEach(function(item) {
                var recapType = item.getAttribute('data-recap-type');
                var recapLine = parseInt(item.getAttribute('data-recap-line'));
                var valueEl = item.querySelector('.engraving-recap-item-value');
                if (!valueEl || recapLine === -1) return;

                var input = form.querySelector('input.engraving_line[data-config-type="' + recapType + '"][data-line-index="' + recapLine + '"]');
                if (input) {
                    input.value = valueEl.textContent || '';
                    var counter = input.closest('.engraving_line_wrapper').querySelector('p');
                    if (counter) counter.innerHTML = input.value.length + '/' + input.getAttribute('maxlength');
                }
            });

            // Restore gold engraving state from recap
            var goldRecapItem = recap.querySelector('.engraving-recap-item[data-recap-type="glass"][data-recap-line="-1"]');
            if (goldRecapItem && goldRecapItem.style.display !== 'none') {
                var goldValue = goldRecapItem.querySelector('.engraving-recap-item-value');
                if (goldValue && goldValue.textContent.trim() === 'Yes') {
                    if (_.goldCheckbox) _.goldCheckbox.checked = true;
                    if (_.goldInput) _.goldInput.value = 'Yes';
                }
            }
        });
    }

    customEngraving.prototype.openModalByType = function(type) {
        var overlay = document.querySelector('.engraving-modal-overlay[data-engraving-type="' + type + '"]');
        if (overlay) {
            overlay.classList.add('visible');
            document.body.style.overflow = 'hidden';
        }
    }

    customEngraving.prototype.closeModalByType = function(type) {
        var overlay = document.querySelector('.engraving-modal-overlay[data-engraving-type="' + type + '"]');
        if (overlay) overlay.classList.remove('visible');
        document.body.style.removeProperty('overflow');
    }

    customEngraving.prototype.getFormType = function() {
        return 'engraving';
    }

    customEngraving.prototype.getFormInputs = function(form) {
        return form.querySelectorAll('input.engraving_line');
    }

    customEngraving.prototype.getFormTermsCheckbox = function(form) {
        return form.querySelector('[name="engraving[terms_sales]"]');
    }

    customEngraving.prototype.getSaveButton = function(form) {
        return form.querySelector('.engraving-save-button');
    }

    customEngraving.prototype.getSavedInput = function(form) {
        return form.querySelector('.engraving-saved-input');
    }

    customEngraving.prototype.hasAnyValue = function(form) {
        var inputs = this.getFormInputs(form);
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].value !== '') return true;
        }
        return false;
    }

    customEngraving.prototype.updateSaveButtonState = function(form) {
        var termsCheckbox = this.getFormTermsCheckbox(form);
        var saveButton = this.getSaveButton(form);
        if (!termsCheckbox || !saveButton) return;

        var hasValue = this.hasAnyValue(form);
        if (termsCheckbox.checked && hasValue) {
            saveButton.removeAttribute('disabled');
            this.editButtons.forEach(function(el) {
                el.removeAttribute('disabled');
            });
        } else {
            saveButton.setAttribute('disabled', '');
            this.editButtons.forEach(function(el) {
                el.setAttribute('disabled', '');
            });
        }
    }

    customEngraving.prototype.load = function() {
        var _ = this;

        // --- Open buttons ---
        _.openButtons.forEach(function(btn) {
            btn.addEventListener('click', function(event) {
                var type = _.getButtonType(btn);
                if (type) {
                    // Reset image to first configuration and clear stale preview
                    _.resetToFirstImage();
                    _.clearAllPreviews();

                    // Restore form inputs from recap values before opening
                    _.restoreFromRecap();

                    _.openModalByType(type);
                    // Defer overlay rebuild to after modal CSS transition completes
                    // so CircleType has correct element dimensions for curved text
                    var overlay = document.querySelector('.engraving-modal-overlay[data-engraving-type="' + type + '"]');
                    if (overlay) {
                        overlay.addEventListener('transitionend', function() {
                            _.currentOverlayType = null;
                            _.switchOverlay(_.firstTypeSlug);
                            var allInputs = overlay.querySelectorAll('input.engraving_line');
                            var hasContent = Array.prototype.some.call(allInputs, function(input) { return input.value.length > 0; });
                            if (hasContent) {
                                var firstInput = allInputs[0];
                                if (firstInput) {
                                    firstInput.focus();
                                    firstInput.setSelectionRange(firstInput.value.length, firstInput.value.length);
                                }
                            }
                        }, { once: true });
                    }
                    // Reset terms checkbox and disable save buttons on open
                    _.forms.forEach(function(form) {
                        var termsCheckbox = _.getFormTermsCheckbox(form);
                        if (termsCheckbox) termsCheckbox.checked = false;
                        var saveBtn = _.getSaveButton(form);
                        if (saveBtn) saveBtn.setAttribute('disabled', '');
                    });
                    // Track engraving click
                    if (typeof dataLayer !== 'undefined') {
                        dataLayer.push({ 'event': 'engrave_click' });
                    }
                }
            });
        });

        // --- Close buttons ---
        document.querySelectorAll('.engraving-modal__close').forEach(function(btn) {
            btn.addEventListener('click', function() {
                var type = btn.getAttribute('data-engraving-type');
                _.closemakerByType(type);
            });
        });

        // --- Overlay background click to close ---
        _.overlays.forEach(function(overlay) {
            overlay.addEventListener('click', function(e) {
                if (e.target === overlay) {
                    _.closemakerByType(overlay.dataset.engravingType);
                }
            });
        });

        // --- Per-form event binding ---
        _.forms.forEach(function(form) {
            var inputs = _.getFormInputs(form);
            var termsCheckbox = _.getFormTermsCheckbox(form);
            var saveButton = _.getSaveButton(form);
            var savedInput = _.getSavedInput(form);
            var overlay = form.closest('.engraving-modal-overlay');
            var modalType = overlay ? overlay.getAttribute('data-engraving-type') : 'engraving';

            // Input keyup: character counting + preview update + save state
            var DISALLOWED_CHARS_RE = /[@#$%^*~=+|\\/<>{}\[\]()_!?.,:;'"`]|\p{Emoji_Presentation}|\p{Extended_Pictographic}/u;
            inputs.forEach(function(input) {
                var cfgType = input.getAttribute('data-config-type');
                var cfg = _.overlayConfigs[cfgType];
                var blockDigits = !!(cfg && cfg.disableNumbers);

                input.addEventListener('beforeinput', function(event) {
                    if (event.data && (DISALLOWED_CHARS_RE.test(event.data) || (blockDigits && /[0-9]/.test(event.data)))) {
                        event.preventDefault();
                    }
                });
                input.addEventListener('paste', function(event) {
                    var pasted = (event.clipboardData || window.clipboardData).getData('text');
                    var stripSource = blockDigits ? DISALLOWED_CHARS_RE.source + '|[0-9]' : DISALLOWED_CHARS_RE.source;
                    var stripRe = new RegExp(stripSource, 'u');
                    if (stripRe.test(pasted)) {
                        event.preventDefault();
                        var cleaned = pasted.replace(new RegExp(stripSource, 'gu'), '');
                        var el = event.target;
                        var start = el.selectionStart, end = el.selectionEnd;
                        el.value = el.value.slice(0, start) + cleaned + el.value.slice(end);
                        el.setSelectionRange(start + cleaned.length, start + cleaned.length);
                        el.dispatchEvent(new Event('keyup'));
                    }
                });
                input.addEventListener('keyup', function(event) {
                    var maxLen = Number(event.target.getAttribute('maxlength'));
                    var currentLen = event.target.value.length;

                    if (currentLen <= maxLen) {
                        var counter = event.target.closest('.engraving_line_wrapper').querySelector('p');
                        if (counter) counter.innerHTML = currentLen + '/' + maxLen;
                    } else {
                        event.target.value = event.target.value.slice(0, maxLen);
                    }

                    // Update overlay preview
                    var lineIndex = parseInt(event.target.getAttribute('data-line-index') || '0');
                    var span = _.overlay ? _.overlay.querySelector('[data-preview-line="' + lineIndex + '"]') : null;
                    if (span) {
                        span.textContent = event.target.value;
                        var cfg = _.overlayConfigs[_.currentOverlayType];
                        if (cfg && cfg.isCurved) _.applyCurve(span, lineIndex);
                    }

                    _.updateSaveButtonState(form);
                });

                input.addEventListener('focus', function(event) {
                    var configType = event.target.getAttribute('data-config-type');
                    var lineIndex = parseInt(event.target.getAttribute('data-line-index') || '0');

                    _.switchOverlay(configType, lineIndex);

                    // Apply gold color if glass and checkbox is checked
                    if (_.overlay) {
                        _.overlay.style.color = (_.goldCheckbox && _.goldCheckbox.checked && _.currentOverlayType === 'glass') ? '#D4AF37' : '';
                    }
                });
            });

            // Terms checkbox
            if (termsCheckbox) {
                termsCheckbox.addEventListener('click', function() {
                    _.updateSaveButtonState(form);
                });
            }

            // Gold engraving checkbox
            if (_.goldCheckbox) {
                _.goldCheckbox.addEventListener('change', function() {
                    if (_.currentOverlayType === 'glass' && _.overlay) {
                        _.overlay.style.color = this.checked ? '#D4AF37' : '';
                    }
                    if (_.goldInput) {
                        _.goldInput.value = this.checked ? 'Yes' : 'No';
                    }
                });
            }

            // Save button
            if (saveButton) {
                saveButton.addEventListener('click', function() {
                    if (savedInput) savedInput.value = 'true';

                    // Find the open button and update recap
                    var openBtn = _.openButtons[0];
                    if (openBtn) {
                        var subtext = openBtn.querySelector('.product-engraving__button__subtext');
                        var recap = openBtn.querySelector('.engraving-recap');
                        var caret = openBtn.querySelector('.product-engraving__button__caret');
                        if (subtext) subtext.classList.add('d-none');
                        if (recap) recap.classList.remove('d-none');
                        if (caret) caret.classList.add('d-none');
                        // Populate recap values
                        var recapItems = recap.querySelectorAll('.engraving-recap-item');
                        recapItems.forEach(function(item) {
                            var recapType = item.getAttribute('data-recap-type');
                            var recapLine = parseInt(item.getAttribute('data-recap-line'));
                            var valueEl = item.querySelector('.engraving-recap-item-value');

                            // Gold engravings recap item — only show if at least one glass has content
                            if (recapType === 'glass' && recapLine === -1) {
                                var glassInputs = form.querySelectorAll('input.engraving_line[data-config-type="glass"]');
                                var hasGlassContent = Array.prototype.some.call(glassInputs, function(inp) { return inp.value.trim() !== ''; });
                                if (hasGlassContent && valueEl && _.goldCheckbox) {
                                    valueEl.innerHTML = _.goldCheckbox.checked ? 'Yes' : 'No';
                                    item.style.display = '';
                                } else {
                                    item.style.display = 'none';
                                }
                                return;
                            }

                            var matchingInput = form.querySelector('input.engraving_line[data-config-type="' + recapType + '"][data-line-index="' + recapLine + '"]');
                            if (matchingInput && valueEl) {
                                valueEl.innerHTML = matchingInput.value;
                            }
                        });
                    }

                    _.closeModalByType(modalType);
                });
            }

            // Reset button
            var resetBtn = document.querySelector('.engraving-recap-reset');
            if (resetBtn) {
                resetBtn.addEventListener('click', function(event) {
                    event.stopPropagation();
                    if (savedInput) savedInput.value = '';

                    var openBtn = _.openButtons[0];
                    if (openBtn) {
                        var subtext = openBtn.querySelector('.product-engraving__button__subtext');
                        var recap = openBtn.querySelector('.engraving-recap');
                        var caret = openBtn.querySelector('.product-engraving__button__caret');
                        if (subtext) subtext.classList.remove('d-none');
                        if (recap) recap.classList.add('d-none');
                        if (caret) caret.classList.remove('d-none');
                    }

                    _.closemakerByType(modalType);
                });
            }
        });



        // --- Edit mode from cookie ---
        if (_.getjsonproperty('customengravingjson') !== 'close') {
            _.editmode(_.getjsonproperty('customengravingjson'));
        } else {
            // Clear all inputs
            _.forms.forEach(function(form) {
                var inputs = _.getFormInputs(form);
                inputs.forEach(function(input) { input.value = ''; });
            });
            _.mobileAddToCartButtons.forEach(function(el) {
                el.classList.remove('d-none');
            });
            if (_.addToCartButton) _.addToCartButton.classList.remove('d-none');
            _.editButtons.forEach(function(el) {
                el.classList.add('d-none');
            });
        }
    }

    customEngraving.prototype.getButtonType = function(btn) {
        var classes = btn.className.split(' ');
        for (var i = 0; i < classes.length; i++) {
            if (classes[i] === 'engraving-button') return 'engraving';
            var match = classes[i].match(/^engraving-(.+)-button$/);
            if (match) return match[1];
        }
        return null;
    }

    customEngraving.prototype.closemakerByType = function(type) {
        var _ = this;
        _.closeModalByType(type);

        // Re-enable save buttons
        _.forms.forEach(function(form) {
            var saveBtn = _.getSaveButton(form);
            if (saveBtn) {
                saveBtn.removeAttribute('disabled');
                saveBtn.classList.remove('d-none');
            }
        });

        _.editButtons.forEach(function(el) {
            el.classList.add('d-none');
        });
        if (_.addToCartButton) _.addToCartButton.classList.remove('d-none');
        _.setjsonproperty('close');

        // Clear all inputs and counters
        _.forms.forEach(function(form) {
            var inputs = _.getFormInputs(form);
            inputs.forEach(function(input) {
                input.value = '';
                var counter = input.closest('.engraving_line_wrapper').querySelector('p');
                if (counter) counter.innerHTML = '0/' + input.getAttribute('maxlength');
            });
            var termsCheckbox = _.getFormTermsCheckbox(form);
            if (termsCheckbox) termsCheckbox.checked = false;
        });

        // Reset gold checkbox and hidden input
        if (_.goldCheckbox) _.goldCheckbox.checked = false;
        if (_.goldInput) _.goldInput.value = 'No';

        // Clear previews
        _.clearAllPreviews();
    }

    customEngraving.prototype.closemaker = function(event) {
        var _ = this;
        var overlay = event.target.closest('.engraving-modal-overlay');
        if (overlay) {
            _.closemakerByType(overlay.dataset.engravingType);
        }
    }

    customEngraving.prototype.setjsonproperty = function(cvalue) {
        var d = new Date();
        d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = 'customengravingjson' + "=" + cvalue + ";" + expires + ";path=/";
    }

    customEngraving.prototype.getjsonproperty = function(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "close";
    }

    customEngraving.prototype.editmode = function(json) {
        var _ = this;
        var jsonedit = JSON.parse(json);

        _.mobileAddToCartButtons.forEach(function(el) {
            el.classList.add('d-none');
        });

        _.forms.forEach(function(form) {
            var defaultHandle = form.getAttribute('data-product-default-handle');
            var overlay = form.closest('.engraving-modal-overlay');
            var modalType = overlay ? overlay.getAttribute('data-engraving-type') : 'engraving';

            if (defaultHandle === jsonedit.editengrave.handle) {
                    form.setAttribute('data-item-key', jsonedit.editengrave.line);

                    if (_.addToCartButton) _.addToCartButton.classList.add('d-none');
                    var saveBtn = _.getSaveButton(form);
                    if (saveBtn) saveBtn.classList.add('d-none');

                    var inputs = _.getFormInputs(form);

                    _.editButtons.forEach(function(el) {
                        el.classList.remove('d-none');
                        el.addEventListener('click', function() {
                            var allValues = [];
                            inputs.forEach(function(inp) { allValues.push(inp.value); });

                            if (typeof theme.cartAddItem !== 'undefined' && theme.cartAddItem.engravingpropertyupdate) {
                                theme.cartAddItem.engravingpropertyupdate(
                                    form.getAttribute('data-item-key'),
                                    allValues[0] || '',
                                    allValues[1] || '',
                                    allValues[2] !== undefined ? allValues[2] : -1,
                                    Array.from(form.querySelectorAll('.glasses-engraving-form-fields input.engraving_line')).map(function(el) { return el.value; })
                                );
                            }

                            var closeBtn = document.querySelector('.engraving-modal__close');
                            if (closeBtn) closeBtn.click();

                            inputs.forEach(function(inp) { inp.value = ''; });
                        });
                    });

                    // Open the modal first, then populate inputs after a short delay
                    // to prevent the open handler from clearing the values
                    if (_.openButtons[0]) _.openButtons[0].click();

                    var properties = jsonedit.editengrave.properties || {};
                    setTimeout(function() {
                        var configSections = form.querySelectorAll('.engraving-config-section');
                        configSections.forEach(function(section) {
                            var configType = section.getAttribute('data-config-type');
                            var sectionInputs = section.querySelectorAll('input.engraving_line');
                            sectionInputs.forEach(function(input, index) {
                                var propName;
                                if (configType === 'bottle') {
                                    propName = 'Decanter-Engraving-Text-Line' + (index + 1);
                                } else if (configType === 'glass') {
                                    propName = 'Glass' + (index + 1) + '-Engraving-Text';
                                } else {
                                    var typeName = configType.split('-').map(function(w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join('-');
                                    propName = typeName + '-Engraving-Text-Line' + (index + 1);
                                }
                                if (properties[propName]) {
                                    input.value = properties[propName];
                                }
                            });
                            // Restore gold engravings checkbox for glass config
                            if (configType === 'glass' && properties['Glass-Gold-Engravings']) {
                                var goldInput = section.querySelector('.gold-engraving-input');
                                if (goldInput) goldInput.value = properties['Glass-Gold-Engravings'];
                                if (properties['Glass-Gold-Engravings'] === 'Yes' && _.goldCheckbox) {
                                    _.goldCheckbox.checked = true;
                                }
                            }
                        });

                        // Autofocus first input if form has content
                        var allInputs = form.querySelectorAll('input.engraving_line');
                        var hasContent = Array.prototype.some.call(allInputs, function(input) { return input.value.length > 0; });
                        if (hasContent) {
                            var firstInput = allInputs[0];
                            if (firstInput) {
                                firstInput.focus();
                                firstInput.setSelectionRange(firstInput.value.length, firstInput.value.length);
                            }
                        }
                    }, 100);
            }
        });
    }

    theme.customEngraving = new customEngraving;

}

theme.customEngraving();
